module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal__container"
  }, [(_vm.error) ? _c('h3', {
    staticClass: "text-explainer text-explainer__error"
  }, [_c('svg', {
    staticClass: "tw-icon icon-important",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
    }
  }), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
    }
  })]), _vm._v("\n    Der er stadig oplysninger der skal udfyldes før der kan indberettes\n  ")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.klasserUdenFag.length > 0) ? _c('div', {
    staticClass: "d-attention"
  }, [_c('svg', {
    staticClass: "tw-icon icon-important",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
    }
  }), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Følgende klasser har ingen fag, og skal derfor ikke indberettes.")]), _vm._v(" "), _c('p', [_vm._v("Slet dem i denne liste, hvis de ikke skal indberettes")]), _vm._v(" "), _c('table', {
    staticClass: "d-table d-table__borders"
  }, [_c('tbody', _vm._l((_vm.klasserUdenFag), function(klasse, key) {
    return _c('tr', {
      key: klasse.klasse_id
    }, [_c('td', [_c('div', {
      staticClass: "grade-name"
    }, [_c('div', {
      staticClass: "hint--top-right d-hidden__dropdown",
      attrs: {
        "aria-label": 'Slet ' + klasse.klassebetegnelse + ' fra indberetningen'
      }
    }, [_c('button', {
      staticClass: "icon__bg-circle icon__bg-circle--danger",
      on: {
        "click": function($event) {
          return _vm.confirmDeleteGrade(klasse)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })])]), _vm._v("\n          " + _vm._s(klasse.klassebetegnelse) + "\n          ")])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('IndberetetPersonale', {
    attrs: {
      "stilData": _vm.stilData
    }
  }), _vm._v(" "), _c('IndberetFag', {
    attrs: {
      "stilData": _vm.stilData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit-bttn__container"
  }, [(_vm.error) ? _c('div', {
    staticClass: "hint--left",
    attrs: {
      "aria-label": "Der er stadig oplysninger der skal udfyldes før der kan indberettes"
    }
  }, [_c('button', {
    staticClass: "bttn bttn--primary bttn--primary--disabled",
    staticStyle: {
      "width": "165px"
    }
  }, [_vm._v("\n        Afslut og indberet\n      ")])]) : _c('button', {
    staticClass: "bttn bttn--primary",
    class: {
      'bttn--loading': _vm.isSendingToStil
    },
    staticStyle: {
      "width": "165px"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Afslut og indberet\n    ")])]), _vm._v(" "), (_vm.messageFromStil.length > 0) ? _c('DModal', {
    attrs: {
      "is-bg-overlay": true,
      "show-close": false
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "doc-modal__header"
  }, [_c('h2', [_vm._v("Svar fra STIL")]), _vm._v(" "), _c('div', {
    staticClass: "doc-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        _vm.messageFromStil = ''
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "doc-modal__body"
  }, [_c('p', {
    staticClass: "message-from-stil"
  }, [_vm._v("\"" + _vm._s(_vm.messageFromStil) + "\"")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal__container__header"
  }, [_c('h2', {
    staticClass: "uppercase"
  }, [_vm._v("Resume")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8911cb34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/KompetenceIndberetningIndberet.vue
// module id = 1715
// module chunks = 1